import { render } from "./client-admin.vue?vue&type=template&id=5ef49736&ts=true"
import script from "./client-admin.vue?vue&type=script&lang=ts"
export * from "./client-admin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__